import { useSearchParams } from 'react-router-dom';
import { REGISTER_ID_SEARCH_PARAM_KEY } from '@/modules/common/constants/search-params.ts';
import { useCurrentUserRegistersQuery } from '@/modules/investor-dashboard/queries/registers.tsx';

export const useGetRegister = (searchRegisterId?: number | string) => {
  const { data: registersData } = useCurrentUserRegistersQuery();
  const [params] = useSearchParams();

  const registerId = searchRegisterId || params.get(REGISTER_ID_SEARCH_PARAM_KEY);

  return (registersData?.data || []).find(
    ({ register_id }) => registerId && register_id === +registerId,
  )?.register_obj;
};
